import BrowserService from '@/services/browserService'

export default (user, userId, page) => {
  const payload = ({
    event: 'page_view',
    platform: BrowserService.platform(),
    site: import.meta.env.VITE_VUE_APP_SITE_NAME,
    language: import.meta.env.VITE_VUE_APP_LOCALE,
    sessionId: BrowserService.sessionId(),
    page: page,
    ecommerce: {
      user,
    },
    _clear: true,
  })
  if (userId) payload.user_id = userId
  window.dataLayer?.push(payload)
}
